<template>
    <div>
        <div class="jumbotron jumbotron-fluid">
            <div class="overlay"></div>
            <div class="container carousel-caption-center">
                <h1 class="font-weight-bold">Ветеринарна клиника "City Jungle" <br>вече е с <span class="header-new font-weight-bold">НОВ</span> <span class="header-loc">АДРЕС</span></h1>
                <h5>гр. София, ж.к. Дружба 2, ул. Обиколна, бл.616</h5>
                <a href="https://maps.app.goo.gl/hyNVcU2diQe2RT4TA" target="_blank" class="btn btn-primary">ЗАВЕДИ МЕ ТАМ</a>
            </div>
        </div>
        <div class="container-fluid mt-0 services text-center">
            <div class="row">
                <div class="col-md-4">
                    <h4>Работно време</h4>
                    <p class="align-middle d-inline-block">Пон-Пет: 9.00-19.00 <br>Съб-Нед: 10.00-17.00</p>
                </div>
                <div class="col-md-4">
                    <h4>Контакти</h4>
                    <p><a  href="tel:0889 392029">0889 392 029</a><br>
                        <a href="tel:024167404">02 416 7404</a></p>
                </div>
                <div class="col-md-4">
                    <h4>Адрес</h4>
                    <p>София, ж.к. Дружба 2, <br>ул.Обиколна, бл.616</p>
                </div>
            </div>
        </div>
        <div class="about">
            <div class="container blog mt-5 mb-5 text-center">
                <div class="row">
                    <div class="col-12">
                        <h2 class="section-title mb-3">Визия и мисия</h2>
                        <p>Нашата мисия е да осигурим висококачествена ветеринарна грижа с фокус върху комфорта, здравето и благополучието на всеки домашен любимец. Вярваме в професионализма, етичността и доверието като основа на връзката ни с животните и техните стопани.</p>
                        <p>Стремим се да бъдем  водещ ветеринарен център, където иновациите, човешкото отношение и медицинската прецизност вървят ръка за ръка. Искаме да променим стандартите в грижата за животните – една усмивка и едно здраво сърце наведнъж.</p>
                        <a class="btn btn-primary mr-1" href="/services">НАШИТЕ УСЛУГИ</a>
                        <a class="btn btn-primary" href="/team">ЕКИП</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="counter">
            <div class="container">
                <div class="row">
                    <div class="col-md-4 text-center"  v-for="counter in counters" :key="counter.key">
                        <div class="title">
                            <h1><b>{{ counter.name }}</b></h1>
                        </div>
                        <div class="body">
                            <p :inner-html.prop="counter.description"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="container blog m-100">-->
            <!--<h2 class="text-center mb-5">Последни новини</h2>-->

            <!--<div class="row">-->
                <!--<div class="card-deck p-sm-3">-->
                    <!--<div class="card" v-for="post in news" :key="post.key" style="border:none !important;">-->
                        <!--<router-link  :to="{name: 'newsDetail', params: { id: post.key }}" style="color: #000; text-decoration: none;">-->
                            <!--<div class="embed-responsive embed-responsive-4by3">-->
                                <!--<img class="card-img-top embed-responsive-item" :src="post.image" alt="Card image cap">-->
                            <!--</div>-->

                            <!--<div class="card-body">-->
                                <!--<h5 class="card-title">{{ post.name | truncate(45, '...') }}</h5>-->
                                <!--<p class="card-text"  :inner-html.prop="post.description | truncate(130, '...')"></p>-->
                            <!--</div>-->
                        <!--</router-link>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
            <!--<div class="col-md-12 text-center">-->
                <!--<router-link class="btn btn-primary" to="/news">Виж всички</router-link>-->
            <!--</div>-->
        <!--</div>-->
        <div class="container blog m-100 text-center">
            <h2 class="section-title">Нашият екип</h2>

            <div class="row">
                <div  v-for="user in team" :key="user.key" class="col-md-4  text-center" style="margin-top: 50px;">
                    <div class="card">
                        <div class="embed-responsive embed-responsive-1by1 rounded-image">
                            <img style="width: 100%;
height: auto;" :src="user.image" alt="" class="card-img-top embed-responsive-item">
                        </div>
                        <div class="title">
                            <h4>{{ user.name }}</h4>
                        </div>
                        <div class="body">
                            <p :inner-html.prop="user.story | truncate(150, '...')"></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 text-center" style="margin-top: 20px;">
                <a class="btn btn-primary" href="/team">Разгледай всички лекари</a>
            </div>
        </div>
        <div class="gallery">
            <div class="container">
                <h1 class="text-center font-weight-bold">Галерия</h1>
                <p class="text-center" style="margin: 20px auto;">
                    Разгледайте част от нашето ежедневие
                </p>

                <div class="row album">
                    <div class="col-md-4 mt-4"  v-for="image in images" :key="image.key">
                        <img style="width: 100%; min-height: 300px; max-height: 300px; height: 100%; object-fit: cover; border-radius: 20px" :src="image.image" alt="" class=" embed-responsive-item">
                    </div>

                </div>
            </div>
            <div class="col-md-12 text-center mt-5">
                <router-link class="btn btn-primary" to="/gallery">Виж всички</router-link>
            </div>
        </div>
        <!--<div class="jumbotron jumbotron-fluid grooming">-->
            <!--<div class="bg"></div>-->
            <!--<div class="overlay"></div>-->
            <!--<div class="container">-->
                <!--<div class="row justify-content-center text-center">-->
                    <!--<div class="col-md-8 top">-->
                        <!--<h1 >Груминг салон "City Jungle"</h1>-->
                        <!--<p class="lead">Цялостна грижа за козината, кожата, лапите и ушите на четириногия Ви приятел.</p>                                  <router-link to="/grooming" class="btn btn-primary btn-lg">Научи повече</router-link>-->

                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->
    </div>
</template>

<script>
import { firebaseAuth } from '../firebase';
import { db } from '../firebase';

export default {
  data() {
    return {
      user: null,
      services: [],
      counters: [],
      news: [],
      images: [],
      team: []
    };
  },
  created() {
      firebaseAuth.onAuthStateChanged((user) => {
      if (user) {
        this.user = user;
      } else {
        this.user = null;
      }
    });
  db.collection('services').limit(4).onSnapshot((snapshotChange) => {
      this.services = [];
      snapshotChange.forEach((doc) => {
          this.services.push({
              key: doc.id,
              name: doc.data().name,
              description: doc.data().description,
          })
      });
  });
      db.collection('counters').limit(3).onSnapshot((snapshotChange) => {
          this.counters = [];
          snapshotChange.forEach((doc) => {
              this.counters.push({
                  key: doc.id,
                  name: doc.data().name,
                  description: doc.data().description,
              })
          });
      });
      db.collection('news').orderBy('createdAt', 'desc').limit(3).onSnapshot((snapshotChange) => {
          this.news = [];
          snapshotChange.forEach((doc) => {
              this.news.push({
                  key: doc.id,
                  name: doc.data().name,
                  description: doc.data().description,
                  image: doc.data().image,
              })
          });
      });
      db.collection('gallery').limit(6).onSnapshot((snapshotChange) => {
          this.images = [];
          snapshotChange.forEach((doc) => {
              this.images.push({
                  key: doc.id,
                  image: doc.data().image,
              })
          });
      });
      db.collection('team').orderBy('order', 'asc').limit(3).onSnapshot((snapshotChange) => {
          this.team = [];
          snapshotChange.forEach((doc) => {
              this.team.push({
                  key: doc.id,
                  name: doc.data().name,
                  image: doc.data().image,
                  story: doc.data().story
              })
          });
      });
  },
  methods: {
    logOut() {
        firebaseAuth.signOut().then(() => {
            firebaseAuth.onAuthStateChanged(() => {
          this.$router.push('/login')
        })
      })
    }
  }
};
</script>
<style>
    .blog {
        margin-top: 100px !important;
        margin-bottom: 100px !important;
        h4 {
            color: #1a1a1a;
        }
    }
    .section-title {
        font-weight: bold;
        color: #43b2d3;
    }
    .rounded-image {
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
    }
    .card {
        border-radius: 20px;
    }
    .pin-bottom {
        position: absolute;
        bottom: 0;
        width: 100%;
    }
    .header-new {
        color: #fff;
        font-weight: bold;
    }
    .header-loc {
        color: #55d2ff;
    }
    .grooming {
        background-image: url("../assets/images/grooming-background.jpg");
        background-size: cover;
        height: 60vh;
        position: relative;
        display: flex;
        align-items: center;
        z-index: 1;
        margin-bottom: 0;
    }
    .jumbotron {
        background-image: url("../assets/images/cityJungle_banner-min.jpg");
        background-size: cover;
        width: 100%;
        background-position-y: center;
        background-position-x: center;
        background-repeat: no-repeat;
        height: calc(76vh - 78px);
        position: relative;
        display: block;
        align-items: center;
        z-index: 1;
        margin-bottom: 0;
    }
    .overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(73, 80, 87, 0.5);
        left: 0;
        top: 0;
        z-index: -1;
        filter: blur(1px);
    }
    .top {
        z-index: 99;
        color: #fff;
    }
    .section {
        height: 100vh;
    }
    .bg-grey {
        background-color: #fbfbfb;
    }
    .avatar {
        width: 50px;
        height: 50px;
        background: #dedede;
        text-align: center;
        margin: 0 auto;
        border-radius: 100%;
    }
    .carousel-caption-center {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        text-align: left;
        color: #fff;
        z-index: 9;
        font-size: 1.5vw;
    }
    .color-red {
        color: red;
    }
    @media only screen and (max-width: 600px) {
        .section {
            height: auto;
        }
        .mt-5-sm {
            margin-top: 30px;
        }
        h1 {
            font-size: 1.6rem;
        }
        h3 {
            font-size: 5vw;
        }
        .jumbotron {
            height: calc(40vh - 78px);
        }
        .blog {
            margin-top: 60px !important;
            margin-bottom: 60px !important;
        }
        .carousel-caption-center {
            h1 {
                font-size: 1.4rem;
            }
        }
    }
</style>
